import type { AssetPickerProps } from '@app/rich-editor'
import type { ReactNode } from 'react'
import { ImageField } from '../fields/image-field'

/**
 * The image block's picker: the same `ImageField` (S3 upload, required alt, focal point) every
 * image slot in the admin uses, bound to the block's `ContentTestimonials.image` relation through the
 * rich-editor's `AssetPickerProvider` seam.
 */
export function ImagePicker({ image }: AssetPickerProps): ReactNode {
	return <ImageField field={image} label="Image" required />
}
